import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, renderImages } from '../data/mock';
import { ChevronDown } from 'lucide-react';
import ContactFormModal from './ContactFormModal';

const Hero = ({ onOpenContactForm }) => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToProject = () => {
    const element = document.getElementById('project');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={renderImages[0].url}
          alt="Papuecas 24"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6">
        <div className="max-w-3xl">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-wide">
            {t.hero.title}
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-10 font-light tracking-wide max-w-2xl mx-auto">
            {t.hero.subtitle}
          </p>
          <button
            onClick={onOpenContactForm}
            className="px-8 py-4 bg-white text-stone-800 text-sm tracking-widest uppercase hover:bg-stone-100 transition-colors"
          >
            {t.hero.cta}
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToProject}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/80 hover:text-white transition-colors animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
